export default __webpack_public_path__ + "static/media/bg_master_08.ec031094.jpg";